import React from 'react';
import _ from "lodash";

const ShowFacebookStatus = ({status, emptyLabel = 'NOT CREATED'}) => {

    return (
        <>
            {status &&
                <>
                    <div
                        className={`facebook-ad-status ${status}`}>
                        {status}
                    </div>
                </>
            }

            {!status &&
                <>
                    <div
                        className={`facebook-ad-status empty`}>
                        {emptyLabel}
                    </div>
                </>
            }
        </>
    )
}

export default ShowFacebookStatus
